import { useState } from 'react'
import { useSport } from '@/hooks/useSport'
import { useApi } from '@/hooks/useApi'
import { fetchTransfers } from '@/lib/api'
import { TransferCard } from '@/components/TransferCard'
import { Skeleton } from '@/components/ui/Skeleton'
import { FilterButtonGroup } from '@/components/ui/FilterButtonGroup'

const STATUS_FILTERS = [
  { label: 'All', value: '' },
  { label: 'Entered', value: 'entered' },
  { label: 'Committed', value: 'committed' },
  { label: 'Withdrawn', value: 'withdrawn' },
]

export default function TransferPortalPage() {
  const { sport, sportLabel } = useSport()
  const [status, setStatus] = useState('')
  const [search, setSearch] = useState('')

  const transfers = useApi(
    () => fetchTransfers(sport, { status: status || undefined, q: search || undefined })
      .then(d => d.transfers || []),
    [sport, status, search],
  )

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">{sportLabel} Transfer Portal</h1>
        <p className="text-sm text-slate-400 mt-1">Track college soccer transfers and commitments</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <FilterButtonGroup options={STATUS_FILTERS} value={status} onChange={setStatus} />
        <input
          type="text"
          placeholder="Search players or schools..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="bg-pitch-800 border border-pitch-700 rounded-lg px-3 py-1.5 text-sm text-slate-200 placeholder-slate-500 focus:ring-1 focus:ring-accent/50 focus:border-accent/50 outline-none flex-1"
        />
      </div>

      {transfers.loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} variant="card" className="h-32" />
          ))}
        </div>
      ) : (transfers.data || []).length === 0 ? (
        <div className="card p-12 text-center">
          <p className="text-slate-400">No transfers found.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {(transfers.data || []).map((t) => (
            <TransferCard key={t.id} transfer={t} />
          ))}
        </div>
      )}
    </div>
  )
}
